export const environment = {
	production: true,
//	apiUrl: 'https://work.sbdw.cobra.local/api/v1',
	apiUrl: 'https://work.cobraconto.hu/api/v1',
	demoApiUrl: 'https://js.devexpress.com/Demos/RwaService/api',
};
